import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import i18n from 'i18n-js';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Table,
    TableBody,
    TableRow,
    TableCell,
    DialogActions,
    Button,
    Chip,
    Box,
} from '@material-ui/core';

import images from 'assets/images';
import { default as ordersStore } from 'store/ordersStore';
import OrdersListStatus from 'components/orders/ordersList/OrdersListStatus';
import { formatTime, formatDate, dateTimeIgnoreTimezone } from 'helpers/datetimeHelper';
import { Text } from 'components/shared';
import { useStyles } from '../styles';
import { useAppSelector } from 'index';
import { SignalREvent, signalRService } from 'services/signalR';
import { OrderDetails, OverdudedOrder } from 'store/ordersStore/reducer';

interface OverdudedOrdersPanelProps {
    navigationBarOpen: boolean;
}

export default function OverdudedOrdersPanel(props: OverdudedOrdersPanelProps) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const orders = useAppSelector((state) => state.orders);
    const location = useAppSelector((state) => state.router.location.pathname);
    const [showOverdudedOrdersModal, setShowOverdudedOrdersModal] = useState(false);

    function handleMessage(overdudedOrders: OverdudedOrder[]) {
        dispatch(ordersStore.actionCreators.setOverdudedOrders(overdudedOrders));
        setShowOverdudedOrdersModal(!!overdudedOrders?.length);
    }

    function handleOrderUpdate(data: OrderDetails) {
        const order: OverdudedOrder = {
            id: data.id,
            orderNumber: data.orderNumber,
            orderCreationDate: data.createDate,
            status: data.status,
            isPaid: data.isPaid,
        };
        dispatch(ordersStore.actionCreators.overdudedOrderUpdated(order));
    }

    const formatedDate = (date: number) => {
        const newDate = dateTimeIgnoreTimezone(date);
        return `${formatTime(newDate)} ${formatDate(newDate)}`;
    };

    useEffect(() => {
        return signalRService.subscribe(SignalREvent.OverdudedOrdersChanged, handleMessage);
    }, []);

    useEffect(() => {
        return signalRService.subscribe(SignalREvent.OrderChanged, handleOrderUpdate);
    }, []);

    useEffect(() => {
        dispatch(ordersStore.actionCreators.getOverdudedOrders());
    }, []);

    function handleAllClicked() {
        setShowOverdudedOrdersModal(false);
        dispatch(ordersStore.actionCreators.getDetailedOverdudedOrders([], true));
        if (location !== '/orders') {
            history.push('/orders', { skipFirstLoad: true });
        }
    }

    function handleDetailsClicked(order: OverdudedOrder) {
        setShowOverdudedOrdersModal(false);
        dispatch(ordersStore.actionCreators.getDetailedOverdudedOrders([], false));
        dispatch(ordersStore.actionCreators.getOrderDetails(order.id, undefined, undefined, true));
        if (location !== '/orders') {
            history.push('/orders', { skipFirstLoad: true });
        }
    }

    function handleStornoClicked(order: OverdudedOrder) {
        handleDetailsClicked(order);
        dispatch(ordersStore.actionCreators.SetShowStornoModal(true));
    }

    return orders.overdudedOrders.length > 0 ? (
        <>
            <Box
                className={classes.overdudedPannel}
                onClick={() => setShowOverdudedOrdersModal(!showOverdudedOrdersModal)}
            >
                {props.navigationBarOpen && (
                    <Text
                        fontSize={13}
                        maxLength={26}
                        text={`${orders.overdudedOrders.length} ${i18n.t(
                            'messages.unclosedOrders'
                        )}`}
                        withoutMore
                    />
                )}
                <img src={images.icons.whiteWarning} alt="white-warning" />
            </Box>
            <Dialog
                open={showOverdudedOrdersModal}
                //onClick={preventProp}
                className={classes.overdudedTable}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    style={{ display: 'flex', justifyContent: 'flex-start' }}
                    id="alert-dialog-title"
                >
                    {`${orders.overdudedOrders.length} ${i18n.t('messages.unclosedOrders')}`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        style={{ display: 'flex', justifyContent: 'flex-start' }}
                        id="alert-dialog-description"
                    >
                        {i18n.t('messages.ordersPreparationTimeOver')}
                    </DialogContentText>
                    <Table aria-label="simple table">
                        <TableBody>
                            {orders.overdudedOrders.map((order) => (
                                <TableRow key={order.id}>
                                    <TableCell component="th" scope="row">
                                        {`№ ${order.orderNumber}`}
                                    </TableCell>
                                    <TableCell align="right">
                                        {formatedDate(order.orderCreationDate)}
                                    </TableCell>
                                    <TableCell align="right">
                                        <OrdersListStatus orderId={order.id} showReady={false} />
                                    </TableCell>
                                    <TableCell align="right">
                                        {!order.isPaid && (
                                            <Button
                                                variant="contained"
                                                size="small"
                                                style={{ marginRight: 10 }}
                                                onClick={() => handleStornoClicked(order)}
                                            >
                                                {i18n.t('navigationTabs.storno')}
                                            </Button>
                                        )}
                                        {order.isPaid && (
                                            <Chip
                                                className={classes.paidLabel}
                                                label={i18n.t('orders.paid')}
                                            />
                                        )}
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => handleDetailsClicked(order)}
                                        >
                                            {i18n.t('common.details')}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions style={{ paddingRight: 34, marginTop: 10 }}>
                    <Button
                        variant="text"
                        onClick={() => setShowOverdudedOrdersModal(false)}
                        style={{ marginBottom: 'unset' }}
                    >
                        {i18n.t('button.close')}
                    </Button>
                    <Button
                        variant="contained"
                        style={{ marginBottom: 'unset' }}
                        onClick={() => handleAllClicked()}
                    >
                        {i18n.t('common.all')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    ) : null;
}
